export default "__VITE_ASSET__b96141d6__"